import { render, staticRenderFns } from "./PartSearchFacetsExpand.vue?vue&type=template&id=f8525074"
import script from "./PartSearchFacetsExpand.vue?vue&type=script&lang=js"
export * from "./PartSearchFacetsExpand.vue?vue&type=script&lang=js"
import style0 from "./PartSearchFacetsExpand.vue?vue&type=style&index=0&id=f8525074&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports